import { Box, styled } from "@mui/material";

export const SMSBalanceWrapper = styled(Box)(() => {
    return {

    }
})